import {BaseModel} from '../baseModel';
import {Journal} from './journal';
import {Partner} from '../res/partner';
import {Invoice} from './invoice';
import {Currency} from '../res/currency';
import {Company} from '../res/company';

/**
 *  Payment.
 */
export class Payment extends BaseModel<number> {
  name?: string;
  date?: any;
  invoices?: any;
  partner?: Partner;
  journal?: Journal;
  currency?: Currency;
  company?: Company;
  paymentType?: string;
  amount?: number;
  state?: string;
  description?: string;
  ref?: string;
  origin?: string;
  setForFuturePayments?: boolean;
  paymentMethodId?: string;
  intent?: boolean;
  createIntent?: boolean;
  financeFee?: number;
  paymentInvoices?: any;
}
